import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/api";
import { useLocation } from "react-router-dom";

const FloatingWA = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  const link = `https://wa.me/${BRAND.waPhone}?text=${encodeURIComponent("Hello Quick Wash!")}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] shadow-xl flex items-center justify-center text-white transition-transform hover:scale-110 animate-float"
      data-testid="floating-whatsapp"
      aria-label="WhatsApp"
    >
      <MessageCircle size={26} />
    </a>
  );
};

export default FloatingWA;
